import { FloatingInput, FloatingLabel } from '@/components/ui/floating-input.tsx'
import { AnimatePresence, motion } from 'motion/react'

interface SuggestionFloatingInputProps {
	id: string
	label?: string
	suggestions: string[]
	onSuggestionClicked: (suggestion: string) => void
	[key: string]: any
}

export default function SuggestionFloatingInput({
	id,
	label = '',
	suggestions = [],
	onSuggestionClicked,
	...props
}: SuggestionFloatingInputProps) {
	return (
		<>
			<div className="relative w-full me-1">
				<FloatingInput id={id} {...props} />
				<FloatingLabel htmlFor={id} className="text-muted-foreground">
					{label}
				</FloatingLabel>
			</div>
			<AnimatePresence initial={false}>
				{suggestions.length > 0 && (
					<motion.div
						className="flex flex-col gap-1 mt-2 ms-2"
						initial={{ opacity: 0, y: -10 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -10 }}
						transition={{ duration: 0.3 }}>
						{suggestions.map((x) => (
							<button
								key={x}
								onClick={() => onSuggestionClicked(x)}
								type="button"
								className="flex w-full cursor-pointer items-center justify-start whitespace-pre-wrap rounded px-2.5 py-1 text-start bg-muted text-gray-400">
								{x}
							</button>
						))}
					</motion.div>
				)}
			</AnimatePresence>
		</>
	)
}
